import './App.css';
import {Loader} from "./components/Loader.js";
import Card from "./components/Card.js"
import Privacy from "./components/Privacy.js"
import How from "./components/How.js"
import Terms from "./components/Terms.js"
import React, {useEffect, useState } from "react";
import {Route, Routes, BrowserRouter} from 'react-router-dom';

import AppContext from "./context/AppContext.js"
import HistoryContext from "./context/HistoryContext.js"
import ParamsContext from "./context/ParamsContext.js"
import CardsContext from "./context/CardsContext.js"
import {GoogleOAuthProvider} from "@react-oauth/google"
import { GOOGLE_CLIENT_ID } from "./io/googleDriveConfig.js"

import LSTM from "./model/Selector"

window.Buffer = window.Buffer || require("buffer").Buffer;

const MainApp = (screen) => {
  return  (
      <>
        {(screen === 'loader') && <Loader />}  
        {(screen === 'reviews') && <Card />}  
      </>
  )
}
const LSTMObject = new LSTM({}, [])
function App() {
  const [screen, setScreen] = useState('loader');
  const [cards, setCards] = useState({})
  const [params, setParams] = useState({})
  const [history, setHistory] = useState({})
  const [spreadsheetAccessData, setSpreadsheetAccessData] = useState({}) 
  const [userGuid, setUserGuid] = useState('');
  const [review, setReview] = useState(0)
  const [pCorrect, setPCorrect] = useState(0);
  const [preSelectedCard, setPreselectedCard] = useState({
    card_id: -1,
    front: '',
    back: '',
    frontAdditional: '',
    backAdditional: '',
  })
  const [cardSelector] = useState(LSTMObject );
  
  useEffect( () => {
    const existingGuid = window.localStorage.getItem('userGuid');
    if (existingGuid == null || existingGuid === '') {
      let guid = crypto.randomUUID();
      window.localStorage.setItem('userGuid',guid);
      setUserGuid(guid);
      return;
    }

    setUserGuid(existingGuid);
  }, [])

  return (
    <div className="App">
            <GoogleOAuthProvider
                clientId={GOOGLE_CLIENT_ID}
                >
      <AppContext.Provider value={{cardSelector, userGuid, setUserGuid, screen, setScreen, spreadsheetAccessData, setSpreadsheetAccessData}} >
      <CardsContext.Provider value={{cards, setCards, pCorrect, setPCorrect, preSelectedCard, setPreselectedCard}} >
      <HistoryContext.Provider value={{history, setHistory, review, setReview}} >
      <ParamsContext.Provider value={{params, setParams}} >
        <BrowserRouter>
          <Routes>
            <Route exact path="/" element={MainApp(screen)}
        />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/how" element={<How />} />
        <Route path="/terms" element={<Terms />} />
        </Routes>
    </BrowserRouter>
      </ParamsContext.Provider>
      </HistoryContext.Provider>
      </CardsContext.Provider>
      </AppContext.Provider>
       </GoogleOAuthProvider> 
    </div>
  );
}

export default App;
